import React from 'react';
import "./Home.css";
import { useEffect, useState } from 'react';
import axios from 'axios';
import CarouselComponent from '../../components/CarouselComponent/CarouselComponent';
import AdminAndNotice from '../../components/template/AdminAndNotice';
// import AboutSection from '../../components/template/About';
import ClientFeedback from '../../components/template/ParentsFeedback';
import ContactSection from '../../components/template/ContactForm';
import HomePagePart2 from '../../components/HomePagePart2/HomePagePart2';
import HomePagePart3 from '../../components/HomePagePart3/HomePagePart3';
import HomePagePart4 from '../../components/HomePagePart4/HomePagePart4';
import HomePagePart5 from '../../components/HomePagePart5/HomePagePart5';
import HomePagePart6 from '../../components/HomePagePart6/HomePagePart6';


const Home = () => {
  const [data, setData] = useState([]);
  const [crousalImage, setCrousalImage] = useState([]);
  const [teacherImage, setTeacherImage] = useState([]);
  const [contactForm, setcontactForm] = useState([]);
  
  const [achievements, setAchievements] = useState("");
  const [ourMoto, setOurMoto] = useState("");
  const [schoolPrograms, setSchoolPrograms] = useState([]);
  
  const [parentFeedback,setParentFeedBack]=useState([]);

  console.log(data);

  // Fetch data when the component mounts
  useEffect(() => {
    let domain = window.location.hostname;
    if (domain === 'localhost') {
      domain = 'demoschoolmanagement.in';
    }

      axios
      .get(`https://dataserver.${domain}/website/get_conf.php`)
      .then((response) => {
        console.log(response.data);
        setData(response.data);
        setCrousalImage(response.data.crowsel);
        setAchievements(response.data.achievements);
        setOurMoto(response.data.our_moto);
        setSchoolPrograms(response.data.school_programs);
        
        setTeacherImage(response.data.teachers);
        setParentFeedBack(response.data.guardians_feedback);
        setcontactForm(response.data.contact_section);
      })
      .catch((err) => {
        console.log(err.message);
      });
    
  }, []);
  console.log(parentFeedback);

  return (
    <div className='homeContainer'>
      <CarouselComponent crousalImage={crousalImage} />
      <HomePagePart2 achievements={achievements} />
      <HomePagePart3 ourMoto={ourMoto} />
      <HomePagePart4 />
      <HomePagePart5 schoolPrograms={schoolPrograms} />
      <AdminAndNotice/>
      <HomePagePart6 teacherImage={teacherImage} />
      <ClientFeedback parentFeedback={parentFeedback} />
      <ContactSection contactForm={contactForm}/>
    </div>
  );
};

export default Home;
